<template>
  <div class="home">

    <LayoutTopComponent></LayoutTopComponent>

    <div class="clsA">
      <div class="clsB">
        <img class="clsD" src=""/>
      </div>
      <div class="clsC">
        <img src="../assets/images/home_two_table_top_right.png"/>
      </div>
    </div>

    <LayoutBottomComponent></LayoutBottomComponent>

  </div>
</template>

<script>

import LayoutTopComponent from '../components/LayoutTopComponent'
import LayoutBottomComponent from '../components/LayoutBottomComponent'

export default {
  data() {
    return {
      oneImgList: [
        {
          url: require("../assets/images/home_view_pager_001.png")
        },
        {
          url: require("../assets/images/home_view_pager_001.png")
        },
        {
          url: require("../assets/images/home_view_pager_001.png")
        }
      ],
      twoList: [
        {
          url: require("../assets/images/home_three_001.png"),
          name: "智能回收柜",
          desc: "HSG3651"
        }, {
          url: require("../assets/images/home_three_002.png"),
          name: "闸机",
          desc: "ZJ4361"
        }, {
          url: require("../assets/images/home_three_003.png"),
          name: "晨检机",
          desc: "CJ9100"
        }
      ]
    }
  }
  ,
  components: {
    LayoutTopComponent,
    LayoutBottomComponent,
  },
  methods: {}


}

</script>


<style lang="less" scoped>


.home {

  .clsA {
    background: #c5eeee;
    margin-top: 200px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 300px;

    .clsB {
      display: flex;
      background: url("../assets/images/profile_three_003.png") no-repeat;
      background-size: 100%;
      width: 80px;
      height: 80px;

      .clsD {

      }
    }

    .clsC {
    }

  }
}


.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

</style>

